import { useSchedulingLink } from 'components/use_scheduling_link'
import { useGetRoutingFormQuery } from 'root-api'

export const useRoutingForm = () => {
  const schedulingLink = useSchedulingLink()
  const { data: routingForm } = useGetRoutingFormQuery(
    { uuid: schedulingLink?.owner_uuid },
    { skip: !schedulingLink || schedulingLink.owner_type !== 'FormBuilder::Form' }
  )

  if (schedulingLink === undefined) return undefined
  if (schedulingLink === null) return null

  if (schedulingLink.owner_type !== 'FormBuilder::Form') {
    return null
  }

  if (routingForm === undefined) return undefined
  if (routingForm === null) return null

  return routingForm
}
